<div *ngIf="global_texts" class="py-4 d-flex flex-column justify-content-center align-items-center">
  <!-- Bubble Title Login -->
  <div class="bubble-step mb-5 bloc-login-form bloc-account">
    <div class="title">
      <h1 [innerHtml]="title"></h1>
    </div>

    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="form-inline">

        <div class="form-group" *ngFor="let controlName of Object.keys(userForm.controls)"
             [ngClass]="{'w-full' : getFormField(controlName)?.type === 'checkbox'}">

          <ng-container [ngSwitch]="getFormField(controlName)?.type">
            <ng-container *ngSwitchCase="'text'">
              <label [innerHtml]="getFormField(controlName)?.label"></label>
              <input class="form-control"
                     type="text"
                     [formControlName]="controlName">
            </ng-container>

            <ng-container *ngSwitchCase="'password'">
              <label [innerHtml]="getFormField(controlName)?.label"></label>
              <input class="form-control with-picto mdp" type="password" [formControlName]="controlName"
                     autocomplete="new-password">
            </ng-container>

            <ng-container *ngSwitchCase="'email'">
              <label [innerHtml]="getFormField(controlName)?.label"></label>
              <input class="form-control with-picto email" type="text" [formControlName]="controlName"
                     autocomplete="new-email">
            </ng-container>

            <ng-container *ngSwitchCase="'radio'">
              <label [innerHtml]="getFormField(controlName)?.label"></label>
              <div class="pt-3 d-flex align-items-center gap-3">
                <label class="custom-radio in-form d-flex align-items-center"
                       *ngFor="let civility of civilities | keyvalue">
                  <input type="radio" name="civility" [id]="civility.key" [value]="civility.value"
                         [formControlName]="controlName">
                  <span class="checkmark small"></span>
                  <span [attr.for]="civility.key" [innerHtml]="civility.value"></span>
                </label>

              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'checkbox'">
              <label class="custom-checkbox in-form d-flex">
                <input type="checkbox" [attr.id]="controlName" [formControlName]="controlName">
                <span class="checkmark"></span>
                <span class="text-label-custom-checkbox" [attr.for]="controlName" [innerHtml]="getFormField(controlName)?.label"></span>
              </label>
            </ng-container>
          </ng-container>

          <!-- Error Messages -->
          <div *ngIf="submitted && userForm.controls[controlName].errors" class="small fw-bold color-red mt-2">
            <div
              *ngIf="userForm.controls[controlName].errors"
              [innerHtml]="app.sharedHelper.getErrorMessage(controlName, global_texts, userForm.controls)">
            </div>
          </div>
        </div>

        <div class="d-flex flex-column flex-md-row justify-content-around w-100 gap-3 my-4">
          <button *ngIf="is_create_account_page" type="button"
                  [routerLink]="'/' + RouterLinks.Login"
                  class="btn btn-solid-red"
                  [innerHtml]="global_texts.cancel"></button>
          <button type="submit" class="btn btn-solid-green"
                  [innerHtml]="is_create_account_page ? global_texts.login_page.create_account : global_texts.save"></button>
        </div>
      </div>
    </form>

  </div>
</div>
